import { Divider, styled } from "@mui/material";


export const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: 'rgba(0, 0, 0, 0.12) !important',
  }));